module.exports = __webpack_public_path__ + "img/Colorization6.a9f2cfd2.webp";